module.exports = __webpack_public_path__ + "img/login_biaoti5.2ab79faf.png";